import { render, staticRenderFns } from "./WatchTheClass.vue?vue&type=template&id=319d633d&scoped=true"
import script from "./WatchTheClass.vue?vue&type=script&lang=js"
export * from "./WatchTheClass.vue?vue&type=script&lang=js"
import style0 from "./WatchTheClass.vue?vue&type=style&index=0&id=319d633d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d633d",
  null
  
)

export default component.exports